import React from "react";
import "../App.css";
const Loader = () => {
  return (
    <div className="outer-ripple">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
